import { Factory } from './factory';
import { TextBox } from '../text-box';
import { Position } from '../position';

export class TextBoxFactory implements Factory<TextBox> {

    buildFromFactory(): TextBox {
        return undefined;
    }

    buildFromObject(jsonObject: any): TextBox {
        const textBox = new TextBox();
        textBox.id = jsonObject.id;
        textBox.pageId = jsonObject.pageId;

        const position = new Position();
        position.x = +jsonObject.x.replace('%', '');
        position.y = +jsonObject.y.replace('%', '');
        position.w = +jsonObject.w.replace('%', '');
        position.h = +jsonObject.h.replace('%', '');
        textBox.position = position;
        textBox.content = jsonObject.c;

        return textBox;
    }

}
